import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import productStoreModule from '@/views/modules/products/productStoreModule'
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app,
        appConfig,
        verticalMenu,
        'app-ecommerce': productStoreModule,
    },
    strict: process.env.DEV,
})
